export default {
      id: "cart-arrow-down-solid-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#cart-arrow-down-solid",
      toString: function () {
        return this.url;
      }
    }